import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";
import { optionShape } from "../index";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
export const DialogOptionStyled = styled.div`
    display: block;
    cursor: pointer;
    list-style-type: none;
    margin: 0px;
    padding: 0px;

    width: 100%;

    border: none;
    border-radius: 0px;

    padding: 0px;

    display: grid;
    gap: 0px;
    grid-template-columns: 35px auto;

    &:hover {
        background-color: ${colors.primary.moon};
    }
`;

const CheckMarkWrapperStyled = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const DialogOptionTextStyled = styled.div`
    text-align: "left";
    color: ${colors.secondary.oolong};
    font-size: ${convertPxToRem(16)};
    line-height: ${convertPxToRem(48)};
`;

// components
import Checkmark from "core/ReusableIcons/Checkmark";

const DialogOption = ({ option, optionRef }) => {
    // state/props
    const {
        isOpen,
        setIsOpen,
        selectedOption,
        setSelectedOption
    } = useFormSelectDialog();

    const isSelected = selectedOption.id === option.id;

    // methods
    const selectOption = () => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    // Handle enter and spacekey
    const handleKeyDown = e => {
        if (!isOpen) return;
        switch (e.key) {
            case "Enter":
            case " ":
                e.preventDefault();
                e.stopPropagation();
                selectOption();
                break;
            default:
                break;
        }
    };

    return (
        <DialogOptionStyled
            role="option"
            ref={optionRef}
            tabIndex="0"
            onClick={selectOption}
            onKeyDown={handleKeyDown}
            aria-selected={isSelected}
            data-testid="dialog-option"
            aria-label={`${option.label}`}
        >
            <CheckMarkWrapperStyled>
                {isSelected && (
                    <Checkmark
                        size={"sm"}
                        fillColor={colors.secondary.oolong}
                    />
                )}
            </CheckMarkWrapperStyled>
            <DialogOptionTextStyled>{option.option}</DialogOptionTextStyled>
        </DialogOptionStyled>
    );
};

export default DialogOption;

// prop-types
DialogOption.propTypes = {
    option: PropTypes.shape(optionShape).isRequired,
    optionRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired
};
